"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoginForm = void 0;
var _react = _interopRequireDefault(require("react"));
var _form = require("./form");
var _formV = require("./formV2");
var _excluded = ["showV2"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var LoginForm = exports.LoginForm = function LoginForm(_ref) {
  var _ref$showV = _ref.showV2,
    showV2 = _ref$showV === void 0 ? false : _ref$showV,
    props = _objectWithoutProperties(_ref, _excluded);
  if (showV2) {
    return /*#__PURE__*/_react["default"].createElement(_formV.FormV2, props);
  }
  return /*#__PURE__*/_react["default"].createElement(_form.Form, _extends({}, props, {
    "data-sentry-element": "Form",
    "data-sentry-component": "LoginForm",
    "data-sentry-source-file": "index.tsx"
  }));
};